import { render, staticRenderFns } from "./AdBanner.vue?vue&type=template&id=a023fada&lang=pug&"
import script from "./AdBanner.vue?vue&type=script&lang=js&"
export * from "./AdBanner.vue?vue&type=script&lang=js&"
import style0 from "./AdBanner.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports